export default {
  WEBSHOP_LINK: 'https://juhaszbrotherswinery.hu/webshop/',
};
